import React, { useCallback } from 'react'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'

import { LiveTradingAccountNavigation } from '../Navigation/LiveTradingAccountNavigation'
import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import TradingAccountStatisticsTable from './TradingAccountStatisticsTable'

interface Props {
  data: {
    id: string
    name: string
  }
}

const TradingAccountStatisticsDetailsPage: React.FC<Props> = ({ data }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const fetchData = useCallback(() => {
    return tradingAccountsApiClient.getTradingAccountStatisticsByTradingAccountId(data.id)
  }, [data.id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data: platformStatistics, isLoading } = useFetchOne(fetchData)

  return (
    <React.Fragment>
      <LiveTradingAccountNavigation data={data} isEdit={false} tab={TradingAccountTab.Statistics} />
      <Loading isLoading={isLoading}>
        {platformStatistics && (
          <TradingAccountStatisticsTable platformStatistics={platformStatistics} />
        )}
      </Loading>
    </React.Fragment>
  )
}

export default TradingAccountStatisticsDetailsPage
